import _ from 'lodash'
import moment from 'moment'
import brush from 'brush'
import {dt, sDuration, mDistance} from 'oderon-commons/src/formatters'
import {preProcessSpec} from 'oderon-commons/src/tables'
import {smallTimeago} from '@/utils'

const hex = n => n == null ? '-' : brush.toHexString(n),
      smallDate = x => x ? moment(x).format('DD/MMM HH:mm') : '-'

function isPI(obj) {
  if ( obj == null ) return false
  return (obj.isPaused || obj.isIgnored)
}

function renderPI(obj) {
  if ( obj == null ) return '-'

  let {isPaused, isIgnored} = obj,
      def     = ['indicator', 'xs', 'mr-1'],
      pColor  = isPaused ? 'yellow' : 'grey',
      iColor  = isIgnored ? 'red' : 'grey'

  let html = `
    <span>
      <span class="${[...def, pColor].join(' ')}">P</span>
      <span class="${[...def, iColor].join(' ')}">I</span>
    </span>
  `

  return {html}
}

function flagsColor(hb) {
  if ( hb.receivedOn != null &&
       moment().diff(hb.receivedOn, 'hours') >= 2 ) {
    return 'red'
  }

  let hasGps    = _.get(hb, 'handshake.hasGps'),
      engineOn  = _.get(hb, 'handshake.engineOn')

  if ( !hasGps ) return 'grey'
  if ( engineOn ) return 'green'
  return 'blue'
}

function rdColor(hb) {
  if ( _.get(hb, 'rawData.length', 0) > 0 ) return 'green'
  return 'grey'
}

function renderAge(d) {
  if ( d == null ) return '-'

  // <span class="age">
  //   Jan/01
  //   <span class="small-timeago">(21D)</span>
  // </span>
  let strTime = moment(d).format('DD/MMM HH:mm'),
      strAgo  = smallTimeago(d)

  let str = `
    <span class="age">
      ${strTime}
      <span class="small-timeago">${strAgo}</span>
    </span>`

  return str
}

function renderHbSummary(hb) {
  if ( hb == null ) return '-'
  let html = `
    ${renderAge(hb.receivedOn || hb.timestamp)}
    <span class="${flagsColor(hb)} indicator xs mx-1">F</span>
    <span class="${rdColor(hb)} indicator xs">RD</span>
  `
  return {html}
}

function queueCount(row) {
  if ( row.queue == null ) return 0
  return (row.queue.active || 0) + (row.queue.waiting || 0)
}

function renderQueue(row) {
  let a = _.get(row, 'queue.active') || 0,
      w = _.get(row, 'queue.waiting') || 0
  return `${a}—${w}`
}

export const defCodes = [
  'id', 'clientIndicators', 'orgName', 'orgIndicators',
  'vehicleCode', 'fw', 'batchNumber',
]

export const fullSpec = preProcessSpec([
  {t: 'ID|', d: 'id', selectable: false},

  {t: 'Módulo P/I', code: 'clientIndicators',
    sortBy: row => isPI(row) ? 1 : 0,
    d: row => renderPI(row)},

  {t: 'Org|', d: 'organization.name', code: 'orgName',
    selectable: false},

  {t: 'Org. P/I', code: 'orgIndicators',
    sortBy: row => isPI(row.organization) ? 1 : 0,
    d: row => renderPI(row.organization)},

  {t: 'Veículo|', d: 'vehicleCode',
    selectable: false},

  {t: 'Firmware|', code: 'fw', d: 'currentFirmwareVersion',
    f: hex,
    selectable: true},

  {t: 'Estoque', code: 'depot', d: 'currentDepot.name',
    selectable: true},

  {t: 'Lote|', d: 'batchNumber', selectable: true},

  {t: '|Observações', d: 'comments', selectable: true,
    sortBy: false},

  {t: 'SimCard|', code: 'iccid', d: 'simCard.iccid',
    selectable: true,},

  {t: 'Operadora|', code: 'operator',
    selectable: true,
    d: 'simCard.operator'},

  {t: 'Último HB|', code: 'lastHb',
    selectable: true,
    sortBy: 'lastHb.receivedOn',
    needsHealth:true,
    d: row => renderHbSummary(row.lastHb)
  },

  {t: 'Último HB consumido|', code: 'lastConsumedHb',
    selectable: true,
    sortBy: 'lastConsumedHb.timestamp',
    needsHealth:true,
    d: row => {
      let lastC   = row.lastConsumedHb,
          lastId  = row.lastHb && row.lastHb.id

      if ( lastC == null ) return '-'
      if ( lastC.id == lastId ) return '(igual ao mais recente)'
      return renderHbSummary(lastC)
    }
  },

  {t: 'Último HB com rawdata|', code: 'lastRawData',
    selectable: true,
    sortBy: 'lastHbWithRawdata.timestamp',
    needsHealth:true,
    d: row => {
      let lastR   = row.lastHbWithRawdata,
          lastId  = row.lastHb && row.lastHb.id

      if ( lastR == null ) return '-'
      if ( lastR.id == lastId ) return '(igual ao mais recente)'
      return renderHbSummary(lastR)
    }
  },

  {t: 'Último trecho|', code: 'lastValidTrip',
    selectable: true,
    sortBy: 'lastValidTrip.startTimestamp',
    needsHealth:true,
    d: row => {
      let trip = row.lastValidTrip
      if ( trip == null ) return '-'

      let html = `
        <span class="driver-name">${trip.driver.name}</span>
        <span class="fixed-1">${smallDate(trip.startTimestamp)}</span>
        <span class="fixed-1">${sDuration(trip.durationS)}</span>
        <span class="fixed-1">${mDistance(trip.distanceM)}km</span>
      `
      return {html}
    }
  },

  {t: 'Queue|', code: 'queue',
    selectable: true,
    sortBy: row => queueCount(row),
    needsHealth:true,
    d: row => renderQueue(row)},

  {t: 'Criado em|', d: 'createdAt',
    selectable: true, f: x => dt(x, 'YYYY-MM-DD HH:mm')}
])
